import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { CarityTheme, Main, Statusbar } from './main';
import './translations/i18n';
import { setDefaultOptions } from 'date-fns';
import { nlBE } from 'date-fns/locale';
import { QueryParamsContextProvider } from './shared';

export function App() {
    const queryClient = new QueryClient({
        defaultOptions: { queries: { refetchOnWindowFocus: false } },
    });
    setDefaultOptions({ locale: nlBE });

    return (
        <CarityTheme>
            <QueryClientProvider client={queryClient}>
                <QueryParamsContextProvider>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <Main />
                        <Statusbar />
                    </LocalizationProvider>
                </QueryParamsContextProvider>
            </QueryClientProvider>
        </CarityTheme>
    );
}
